import useCart from 'hooks/use-cart';
import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { useMarketplaceDispensaryCategoriesQuery } from 'types/graphql';
import { GenericCategoryRoute } from 'src/generics/data';
import { toGenericCategoryRoute } from 'src/generics/data/generic-dispensary-category';
import { getCategoriesForMenuForState } from 'shared/helpers/products';

import { UseCategoriesReturn } from '../categories.types';

const transformData = (categories, categoriesToFilterBy): GenericCategoryRoute[] =>
  categories
    .filter(({ value }) => categoriesToFilterBy.includes(value))
    .map(({ value }) => {
      if (!toGenericCategoryRoute.has(value)) {
        throw new Error(`${value as string} cannot be converted to a GenericCategoryRoute`);
      }

      return toGenericCategoryRoute.get(value);
    });

export function useMarketplaceDispensaryGenericCategoryRoutes(): UseCategoriesReturn {
  const { menuType } = useCart();
  const { dispensary, loading: isDispensaryLoading } = useDispensary();

  const filters = {
    dispensaryId: dispensary?.id,
    pricingType: menuType,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Status: `Active`,
    removeProductsBelowOptionThresholds: true,
    useCache: true,
  };

  const { data, loading: isQueryLoading } = useMarketplaceDispensaryCategoriesQuery({
    variables: { filters },
    skip: !dispensary,
  });

  const isLoading = isDispensaryLoading || isQueryLoading;
  const categoriesForMenuForState = getCategoriesForMenuForState(dispensary?.location?.state);
  const preLoadedCategories = dispensary?.activeCategories || [];
  const dispensaryCategories = data?.filteredProducts?.categories ?? [];

  if (dispensaryCategories.length) {
    return {
      categories: transformData(categoriesForMenuForState, dispensaryCategories),
      loading: isLoading,
    };
  }

  if (preLoadedCategories.length) {
    return {
      categories: transformData(categoriesForMenuForState, preLoadedCategories),
      loading: isLoading,
    };
  }

  return {
    categories: transformData(categoriesForMenuForState, categoriesForMenuForState),
    loading: isLoading,
  };
}
